import { Component, forwardRef, Input, OnChanges, OnDestroy, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export const PRIVATE_ORDER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ICPrivateOrderDefaultsComponent),
  multi: true,
};

/**
 * ICPrivateOrderDefaultsComponent
 * ----------------------------------
 *
 *  This is a copy of the component in ICPrivateOrderComponent.
 * It is used only in order entry defaults context.
 */
@Component({
  selector: "ic-private-order-defaults",
  templateUrl: "./html/ic-private-order-defaults.component.html",
  providers: [PRIVATE_ORDER_VALUE_ACCESSOR],
  standalone: false,
})
export class ICPrivateOrderDefaultsComponent
  implements OnInit, OnDestroy, OnChanges, ControlValueAccessor
{
  /**********************************************************************/
  /* INPUT */

  @Input() inputId: string;

  @Input("loading") isLoading: boolean = true;

  @Input("label") input_label: any = "Private Order";

  public onModelChange: Function = (value: any) => {};
  public onModelTouched: Function = () => {};

  /**********************************************************************/
  /* DATA */

  public data: any = {
    label: "Private Order",
    value: null, // ExecutionType enum
    locked: false,
  };

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */

  constructor() {}

  /**********************************************************************/
  /* LIFE CYCLE HOOKS */
  ngOnInit() {
    this.initialize();
  }

  ngOnDestroy() {}

  ngOnChanges() {
    this.initialize();
  }

  /**********************************************************************/
  /* INITIALIZATION */
  public initialize(): void {
    this.data.label = this.input_label;
  }

  /**********************************************************************/
  /* ControlValueAccessor */

  public writeValue(value: any): void {
    this.data.value = value;
    if (!this.isLoading) {
      this.onModelChange(this.data.value);
    }
  }

  public registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  public registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  /**********************************************************************/
  /* BASIC - API */

  public load(value: boolean): void {
    if (typeof value === "boolean" || value === null) {
      this.data.value = value;
    } else {
      logger.out.error(`ERROR: icPrivateOrder.load(): failed to load '${value}'`);
    }
  }

  public reset(): void {
    this.data.value = null;
    this.data.locked = false;
  }

  public lock(): void {
    this.data.locked = true;
  }

  public unlock(): void {
    this.data.locked = false;
  }
  /**********************************************************************/
  /* ON CHANGES */

  public onValueChange(): void {
    this.writeValue(this.data.value);
  }
}
